class cOptionsSubscription {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnSaveSubscriptionOptions = $("#save-subscription-options-btn");
        var elBtnSaveSubscriptionLevels = $("#save-subscription-levels-btn");
        this.elSubscriptionOptionsEditForm = $('#subscription-options-form');
        this.elSubscriptionLevelsEditForm = $('#subscription-levels-form');
        $(elBtnSaveSubscriptionOptions).click(function (e) { return self.submitSubscriptionOptions(this, e); });
        $(elBtnSaveSubscriptionLevels).click(function (e) { return self.submitSubscriptionLevels(this, e); });
    }
    submitSubscriptionOptions(btn, e) {
        $(btn).button('loading');
        $(this.elSubscriptionOptionsEditForm).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/updatesubscription/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
    submitSubscriptionLevels(btn, e) {
        $(btn).button('loading');
        $(this.elSubscriptionLevelsEditForm).ajaxSubmit({
            url: URL_ADMIN + '/sourcesdb/updatesubscriptionlevels/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () { location.reload(); }, 3000);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
}
